import { Component, OnInit } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { AuthService } from '../../core/auth/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-acesso-negado',
  standalone: true,
  imports: [ButtonModule],
  templateUrl: './acesso-negado.component.html',
  styleUrl: './acesso-negado.component.scss'
})
export class AcessoNegadoComponent implements OnInit{
  constructor(private authservice: AuthService, private router:Router) {}

  ngOnInit(): void {    

  }

  login() {
    this.authservice.logout();
  }
}
